module.exports = __webpack_public_path__ + "img/STORY_cards.ded50ae7.png";